import * as React from 'react';
import classNames from 'classnames';
import {InjectedSubmenuProps} from './ActionSubmenu';

interface ActionItemProps {
    title: string;
    className?: string;
    disabled?: boolean;
    icon?: JSX.Element;
    onActionClick?: () => void;
    children?: React.ReactElement<InjectedSubmenuProps>;
    renderSubmenu?: (props) => JSX.Element;
}

interface ActionItemState {
    submenuOpen: boolean;
}

export default class ActionItem extends React.Component<ActionItemProps, ActionItemState> {
    constructor(props) {
        super(props);

        this.state = {
            submenuOpen: false
        };

        this.toggleSubmenu = this.toggleSubmenu.bind(this);
        this.closeSubmenu = this.closeSubmenu.bind(this);
        this.onClick = this.onClick.bind(this);
    }

    toggleSubmenu() {
        this.setState(({submenuOpen}) => ({
            submenuOpen: !submenuOpen
        }));
    }

    closeSubmenu() {
        this.setState({submenuOpen: false});
    }

    onClick(e) {
        const {disabled, onActionClick, children, renderSubmenu} = this.props;
        if (!disabled) {
            onActionClick && onActionClick();
            if (children || renderSubmenu) {
                this.toggleSubmenu();
            }
        }
    }

    render() {
        const {title, className, disabled, icon, children, renderSubmenu: Submenu} = this.props;
        const {submenuOpen} = this.state;
        const itemClass = classNames('action-tab', className, {
            selected: submenuOpen,
            'action-tab-open': submenuOpen,
            disabled
        });
        const submenuChildren =
            children &&
            React.cloneElement(children, {open: submenuOpen, closeSubmenu: this.closeSubmenu});
        return (
            <div>
                <div className={itemClass} onClick={this.onClick}>
                    {title}
                    {icon}
                </div>
                {submenuChildren}
                {submenuOpen && Submenu && <Submenu closeSubmenu={this.closeSubmenu} />}
            </div>
        );
    }
}
